/* Souvence funnel 1 — resolution d'une destination tapee vers un ou plusieurs gabarits.
   Aucune dependance. Expose window.SVSearch. Testable sous Node (module.exports). */
(function (root) {
  'use strict';

  var DICE_MIN = 0.62;   // remonte de 0,55 : moins de faux positifs

  function normalize(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')  // accents
      .replace(/[^a-z0-9]+/g, ' ')                        // ponctuation
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* "portugal 2" et "portugal" designent la meme destination, avec deux
     couvertures differentes. On les regroupe sous une meme cle. */
  function destKey(normalized) {
    return normalized.replace(/\s+\d+$/, '').trim();
  }

  function bigrams(s) {
    var t = s.replace(/\s/g, ''), out = [];
    for (var i = 0; i < t.length - 1; i++) out.push(t.slice(i, i + 2));
    return out;
  }

  /* Coefficient de Dice sur bigrammes : 0 = rien en commun, 1 = identique. */
  function dice(a, b) {
    if (a === b) return 1;
    var A = bigrams(a), B = bigrams(b);
    if (!A.length || !B.length) return 0;
    var pool = B.slice(), hits = 0;
    for (var i = 0; i < A.length; i++) {
      var j = pool.indexOf(A[i]);
      if (j !== -1) { pool.splice(j, 1); hits++; }
    }
    return (2 * hits) / (A.length + B.length);
  }

  function Search(index, aliasFile, lang) {
    this.index = index || [];
    // Langue de la page, sur deux lettres. Sert a ne montrer que les
    // couvertures ecrites dans cette langue (branche couple / anniversaire).
    this.lang = String(lang || 'en').slice(0, 2).toLowerCase();
    var data = aliasFile || {};
    this.aliases = data.aliases || {};
    this.blocked = {};
    (data.nonSearchable || []).forEach(function (t) { this.blocked[t] = 1; }, this);

    // alias normalise -> liste de titres de gabarit
    this.byAlias = {};
    Object.keys(this.aliases).forEach(function (title) {
      this.aliases[title].forEach(function (a) {
        (this.byAlias[a] = this.byAlias[a] || []).push(title);
      }, this);
    }, this);
  }

  /* La carte « Mon enfant » montre d'abord les gabarits bebe, puis ces deux
     gabarits Classic, dans cet ordre. Demande de Raphael du 2026-09-10. */
  var CHILD_EXTRA = ['Editorial', 'Gallery'];

  /* Sous-ensemble sur lequel on cherche : jamais tout l'index (§4.3). */
  Search.prototype.pool = function (category, occasion) {
    var blocked = this.blocked;
    var index = this.index;
    var base = index.filter(function (e) {
      if (e.c !== category) return false;
      if (occasion && e.o && e.o !== occasion) return false;
      return !blocked[e.t];
    });
    // Couple / anniversaire : les couvertures portent un texte imprime. On ne
    // montre que celles ecrites dans la langue de la page. Aucune couverture
    // allemande n'existe : l'allemand retombe donc sur l'anglais.
    if (category === 'love' && occasion === 'anniversary') {
      var voulue = this.lang === 'fr' ? 'fr' : 'en';
      var memeLangue = base.filter(function (e) { return e.lg === voulue; });
      return memeLangue.length ? memeLangue : base;
    }

    if (category !== 'child') return base;

    CHILD_EXTRA.forEach(function (theme) {
      for (var i = 0; i < index.length; i++) {
        if (index[i].f === 'Classic' && index[i].theme === theme
            && !blocked[index[i].t]) { base.push(index[i]); return; }
      }
    });
    return base;
  };

  /* Tous les gabarits du meme groupe que ces titres : "Portugal" ramene aussi
     "Portugal 2", pour proposer les deux couvertures a l'ecran 3. */
  Search.prototype.byTitles = function (pool, titles) {
    var keys = {};
    titles.forEach(function (t) { keys[destKey(normalize(t))] = 1; });
    return pool.filter(function (e) { return keys[destKey(e.n)]; });
  };

  /**
   * Resolution par PALIERS, du plus sur au plus permissif. On s'arrete au
   * premier palier non vide et on ne melange jamais deux paliers.
   *
   * C'est ce qui corrige le probleme « PAR » → Grece + Paris : avant, un bonus
   * de prefixe mettait « paris » (titre) et « paros » (alias de Grece) au meme
   * score. Maintenant un prefixe de TITRE bat toujours un prefixe d'alias.
   *
   * @returns {{matches: Array, how: string, query: string}}
   *   how = 'exact' | 'prefix' | 'alias-prefix' | 'fuzzy' | 'none'
   */
  Search.prototype.resolve = function (raw, category, occasion, limit) {
    var q = normalize(raw);
    var pool = this.pool(category, occasion);
    var none = { matches: [], how: 'none', query: q };
    if (!q) return none;

    var tiers = this.tiers(q, pool);
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].titles.length) {
        var base = this.byTitles(pool, tiers[i].titles);
        return {
          matches: this.withCountrySiblings(pool, base).slice(0, limit || 12),
          how: tiers[i].how,
          query: q
        };
      }
    }
    return none;
  };

  /* Chercher « Marrakech » doit aussi proposer « Morocco » : c'est le meme
     pays. On garde le resultat exact EN TETE, puis les autres albums du pays.
     Le pays vient de custom.template_country, ecrit en base. Les gabarits
     sans pays (Blank, Asia, les Ski trip) ne declenchent aucun regroupement. */
  Search.prototype.withCountrySiblings = function (pool, base) {
    var seen = {}, countries = {}, out = [];
    base.forEach(function (e) { seen[e.id] = 1; out.push(e); if (e.k) countries[e.k] = 1; });
    pool.forEach(function (e) {
      if (!seen[e.id] && e.k && countries[e.k]) { seen[e.id] = 1; out.push(e); }
    });
    return out;
  };

  /* Suggestions au fil de la frappe : memes paliers, mais on remonte une
     entree par DESTINATION (pas par gabarit), c'est une liste a choisir. */
  Search.prototype.suggest = function (raw, category, occasion, limit) {
    var q = normalize(raw);
    if (q.length < 2) return [];
    var pool = this.pool(category, occasion);
    var tiers = this.tiers(q, pool);
    // On ne melange pas les paliers : « par » propose Paris, pas la Grece
    // (qui n'arrive que par l'alias « paros »).
    var tier = null;
    for (var t = 0; t < tiers.length; t++) { if (tiers[t].titles.length) { tier = tiers[t]; break; } }
    if (!tier) return [];
    tiers = [tier];

    var seen = {}, out = [];
    for (var i = 0; i < tiers.length && out.length < (limit || 5); i++) {
      for (var j = 0; j < tiers[i].titles.length && out.length < (limit || 5); j++) {
        var entries = this.byTitles(pool, [tiers[i].titles[j]]);
        if (!entries.length) continue;
        var key = destKey(entries[0].n);
        if (seen[key]) continue;
        seen[key] = 1;
        out.push({ label: entries[0].t.replace(/\s+\d+$/, ''), entry: entries[0], how: tiers[i].how });
      }
    }
    return out;
  };

  /* Les 4 paliers, dans l'ordre. Chacun rend une liste de titres triee. */
  Search.prototype.tiers = function (q, pool) {
    var self = this;
    var aliasesOf = function (title) { return self.aliases[title] || []; };

    // 1 — le titre normalise, ou un alias, est EXACTEMENT ce qui a ete tape.
    var exact = pool.filter(function (e) { return destKey(e.n) === destKey(q); })
                    .map(function (e) { return e.t; });
    Object.keys(this.aliases).forEach(function (title) {
      if (aliasesOf(title).indexOf(q) !== -1) exact.push(title);
    });

    // 2 — le titre COMMENCE par ce qui a ete tape. Le plus court d'abord :
    //     « par » doit proposer Paris avant Parisienne s'il y en avait une.
    var prefTitle = q.length >= 2
      ? pool.filter(function (e) { return e.n !== q && e.n.indexOf(q) === 0; })
            .sort(function (a, b) { return a.n.length - b.n.length; })
            .map(function (e) { return e.t; })
      : [];

    // 3 — seulement ensuite, un ALIAS commence par ce qui a ete tape.
    var prefAlias = [];
    if (q.length >= 3) {
      Object.keys(this.aliases).forEach(function (title) {
        var hit = aliasesOf(title).some(function (a) { return a !== q && a.indexOf(q) === 0; });
        if (hit) prefAlias.push(title);
      });
    }

    // 4 — dernier recours : la faute de frappe. Dice sur bigrammes.
    var fuzzy = [];
    if (q.length >= 4) {
      var scored = {};
      var keep = function (title, candidate) {
        var d = dice(q, candidate);
        if (d > (scored[title] || 0)) scored[title] = d;
      };
      pool.forEach(function (e) { keep(e.t, e.n); });
      Object.keys(this.aliases).forEach(function (title) {
        aliasesOf(title).forEach(function (a) { keep(title, a); });
      });
      fuzzy = Object.keys(scored)
        .filter(function (t) { return scored[t] >= DICE_MIN; })
        .sort(function (a, b) { return scored[b] - scored[a]; });
    }

    var uniq = function (arr) {
      var seen = {}, out = [];
      arr.forEach(function (t) { if (!seen[t]) { seen[t] = 1; out.push(t); } });
      return out;
    };

    return [
      { how: 'exact',        titles: uniq(exact) },
      { how: 'prefix',       titles: uniq(prefTitle) },
      { how: 'alias-prefix', titles: uniq(prefAlias) },
      { how: 'fuzzy',        titles: uniq(fuzzy) }
    ];
  };

  /* Texte affichable dans la police Souvence : espace + A-Z + a-z, rien d'autre. */
  Search.prototype.constructor.toSouvenceType = function (raw) {
    return String(raw == null ? '' : raw)
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[0-9]+/g, ' ')          // la police n'a pas de chiffres
      .replace(/[^A-Za-z ]+/g, ' ')     // tirets, apostrophes, ponctuation
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  };

  var api = { Search: Search, normalize: normalize, dice: dice, destKey: destKey,
              toSouvenceType: Search.constructor.toSouvenceType };
  api.toSouvenceType = Search.toSouvenceType;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SVSearch = api;
})(typeof window !== 'undefined' ? window : globalThis);
